import { FETCH_CARRIER_RATES } from '../actions/types'
import dollar_price from '../components/general/DollarPrice'

const normalizeRatesPayload = payload => {
  if (Array.isArray(payload)) return payload
  if (payload && Array.isArray(payload.rates)) return payload.rates
  if (payload && payload.data && Array.isArray(payload.data.rates)) return payload.data.rates
  return []
}

export default (state = [], action) => {
  switch (action.type) {
    case FETCH_CARRIER_RATES:
      const rates = normalizeRatesPayload(action.payload)
      const carrierValue = action.carrierValue
      if (rates.length === 0) return []

      const formattedRates = rates
        .map(carrier => {
          const packageType = carrier.packageType
          return {
            ...carrier,
            packageType:
              carrierValue === 'stamps_com' && packageType
                ? packageType
                    .split('_')
                    .map(words => words.charAt(0).toUpperCase() + words.slice(1))
                    .join(' ')
                : ''
          }
        })
        .map(carrier => {
          const { estimatedDeliveryDate, packageType, serviceType, rateTotal } = carrier
          const deliveryDate = estimatedDeliveryDate
            ? ` (ETA ${new Date(estimatedDeliveryDate).toLocaleDateString('en-us', { month: 'short', day: 'numeric' })}`
            : ' (ETA N/A'
          const estimateTotal = dollar_price((parseFloat(rateTotal) || 0) * 100)

          return {
            ...carrier,
            serviceType: `${serviceType} ${packageType}${deliveryDate}) - $${estimateTotal}`
          }
        })

      return formattedRates.sort((a, b) => (parseFloat(a.rateTotal) || 0) - (parseFloat(b.rateTotal) || 0))
    case 'CLEAR_CARRIER_RATES':
      return []
    default:
      return state
  }
}
